export type Toast = (message: string) => void;

const TOAST_MIN_MS = 3_400;
const TOAST_MS_PER_CHARACTER = 110;
const TOAST_MAX_MS = 8_000;

/**
 * How long a toast stays up: 110 ms per character, at least 3.4 s and at most
 * 8 s. A message that wraps to two lines on a phone (about 50 characters) gets
 * time to be read; a short one keeps the usual 3.4 s.
 */
export function toastDurationMs(message: string): number {
  return Math.min(TOAST_MAX_MS, Math.max(TOAST_MIN_MS, [...message].length * TOAST_MS_PER_CHARACTER));
}

/** Short status messages in a polite live region (one at a time; a new one replaces it and gets its own time). */
export function createToast(element: HTMLElement): Toast {
  let timer = 0;
  return (message) => {
    element.textContent = message;
    element.classList.add('is-visible');
    window.clearTimeout(timer);
    timer = window.setTimeout(() => element.classList.remove('is-visible'), toastDurationMs(message));
  };
}
